import { GoSync } from "react-icons/go";

export const Spinner = () => {
  return (
    <div className="flex items-center justify-center">
      <GoSync className="mr-1 h-1 w-1 animate-[spin_3s_reverse_linear_infinite]" />
    </div>
  );
};
